<template>
  <div>
    <mdb-list-group class="max-size">
      <a @click="clickUser(u)" v-for="u in users" :key="id + (u || Math.random())">
        <mdb-list-group-item>
          {{usersRef[u] ? usersRef[u].displayName : "not loaded"}}
          <span>
            <a v-if="acceptable" @click="$emit('accept-user', u)" class="material-icons">done</a>
            <a v-if="removable" @click="$emit('remove-user', u)" class="material-icons">clear</a>
          </span>
        </mdb-list-group-item>
      </a>
    </mdb-list-group>
  </div>
</template>

<script>
import { mdbListGroup, mdbListGroupItem } from "mdbvue";
import { mapState } from "vuex";
export default {
  name: "ListUsers",
  components: {
    mdbListGroup,
    mdbListGroupItem
  },
  props: ["users", "removable", "acceptable"],
  computed: mapState("social", ["usersRef"]),
  data() {
    return {
      id: Math.random() + "-"
    };
  },
  methods: {
    clickUser: function(u) {
      if (this.acceptable && !this.removable) {
        this.$emit("accept-user", u);
      }
      if (this.removable && !this.acceptable) {
        this.$emit("remove-user", u);
      }
    }
  }
};
</script>

<style>
.max-size {
  max-height: 300px;
  overflow-y: auto;
}
</style>